import * as R from 'ramda';

import {createSelector} from 'reselect';
import {getItemsArray} from 'redux/hor/module/selectors';

export const getClientOpenRequestsSelector = createSelector(
  state => state.requestsOpen,
  getItemsArray
);

export const getClientOpenRequestParamsSelector = createSelector(
  state => state.requestsOpen,
  R.compose(
    R.pick(['limit', 'offset', 'count']),
    R.defaultTo({})
  )
);